import {
  MEASURETOOL_START_MEASURING,
  MEASURETOOL_END_MEASURING,
  MEASURETOOL_SET_PIXELS,
  MEASURETOOL_RESET, DRAWINGTOOLBAR_MOUSECLICMEASURE
} from "../lib/types";

export const startToolMeasuring = ( x1, y1 ) => dispatch => {
  dispatch({
    type: MEASURETOOL_START_MEASURING,
    payload: { x: x1, y: y1 }
  });
};

export const endToolMeasuring = ( x2, y2 ) => dispatch => {
  dispatch({
    type: MEASURETOOL_END_MEASURING,
    payload: { x: x2, y: y2 }
  });
};

export const emitLineLenght = length => dispatch => {
  dispatch({
    type: MEASURETOOL_SET_PIXELS,
    payload: length
  });
};

export const resetToolMeasurement = () => dispatch => {
  dispatch({
    type: MEASURETOOL_RESET
  });


};

export const mouseClickMeasure = mouseClickMeasure => dispatch => {
  dispatch({
    type: DRAWINGTOOLBAR_MOUSECLICMEASURE, // DRAWINGTOOLBAR_MEASURETOOL_EDIT,
    payload: mouseClickMeasure
  });
};




// WEBPACK FOOTER //
// ./src/actions/measuretool-actions.js